import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface SearchInputProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Search…',
  autoFocus,
  className,
}) => {
  return (
    <div
      className={`relative flex items-center h-10 px-3 rounded-full border border-border-secondary bg-surface-primary focus-within:border-primary-400 transition-colors ${className ?? ''}`}
    >
      <MagnifyingGlassIcon className="w-5 h-5 text-text-tertiary shrink-0" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className="flex-1 min-w-0 ml-2 bg-transparent text-sm text-text-primary placeholder:text-text-tertiary focus:outline-none"
      />
      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={() => onChange('')}
          className="ml-1 p-1 rounded-full text-text-tertiary hover:text-text-primary hover:bg-neutral-100 dark:hover:bg-neutral-800"
        >
          <XMarkIcon className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
